<template>
    <div class="equipment-search-container">
        <div class="equipment-search-filter">
            <div class="equipment-search-select">
                <el-select v-model="classify" placeholder="选择设备类别" @change="$emit('deviceClassifyChanged', classify)">
                    <el-option
                        v-for="item in deviceClassifyOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div v-if="classify === '变配电设备'" class="equipment-search-select">
                <el-select v-model="type" @change="$emit('filter', type)">
                    <el-option
                        v-for="item in deviceTypeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="equipment-search-device">
                <el-input v-model="deviceName" placeholder="请输入设备名称"></el-input>
            </div>
            <div class="equipment-search-button">
                <el-button type="primary" @click="$emit('query', deviceName)">查询</el-button>
            </div>
        </div>
        <div class="equipment-search-count">
            设备数量 : <span>{{ count }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        count: {
            type: Number,
            default: 0
        },
        deviceClassify: Array,
        deviceTypeOptions: Array,
    },
    data () {
        return {
            classify: '变配电设备',
            type: '',
            deviceName: '',
        }
    },
    methods: {

    },
    computed: {
        deviceClassifyOptions: function () {
            return this.deviceClassify.map(item => {
                return {value: item, label: item};
            })
        }
    },
    watch: {
        classify: function (val, oldVal) {
            this.type = '';
            this.deviceName = '';
        }
    }
}
</script>

<style lang="less" scoped>
.equipment-search-container {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 1px;
    background: white;

    .equipment-search-filter {
        display: flex;
        align-items: center;

        .equipment-search-select {
            margin-left: 24rem;
        }

        .equipment-search-device {
            .w(260);
            margin-left: 24rem;
        }

        .equipment-search-button {
            margin-left: 24rem;

            .el-button {
                .w(96);
            }
        }
    }

    .equipment-search-count {
        padding-right: 24rem;
        font-size: 18rem;
        font-weight: 500;

        span {
            color: #0D94FF;
        }
    }
}

.el-select {
    .w(260);
}

</style>